import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../auth/AuthContext";

export default function DashboardLayout({ children }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const role = user?.role; // ✅ FIX

  const nav = {
    business: [
      { label: "Dashboard", path: "/business/dashboard" },
      { label: "Profile", path: "/business/profile" },
      { label: "Settings", path: "/business/settings" }
    ],
    reseller: [
      { label: "Dashboard", path: "/reseller/dashboard" },
      { label: "Clients", path: "/reseller/clients" },
      { label: "Analytics", path: "/reseller/analytics" },
      { label: "Settings", path: "/reseller/settings" }
    ],
    admin: [
      { label: "Dashboard", path: "/admin/dashboard" },
      { label: "Switcher", path: "/admin/switcher" },
      { label: "Vacancies", path: "/admin/jobs" }
    ]
  };

  if (!role) return null;

  return (
    <div className="min-h-screen bg-black text-white flex flex-col">

      {/* TOP BAR */}
      <header className="border-b border-neutral-800 bg-black/70 backdrop-blur">
        <div className="max-w-7xl mx-auto px-8 py-4 flex justify-between items-center">

          <div
            className="cursor-pointer"
            onClick={() => navigate(`/${role}/dashboard`)}
          >
            <h1 className="font-bold text-lg">AxuCore</h1>
            <p className="text-xs text-neutral-500 capitalize">
              {role} control system
            </p>
          </div>

          <nav className="hidden md:flex gap-8 text-sm text-neutral-400">
            {nav[role]?.map(item => (
              <button
                key={item.path}
                onClick={() => navigate(item.path)}
                className="hover:text-white transition"
              >
                {item.label}
              </button>
            ))}
          </nav>

          <button
            onClick={logout}
            className="bg-violet-600 hover:bg-violet-700 px-4 py-2 rounded-lg text-sm"
          >
            Logout
          </button>
        </div>
      </header>

      {/* CONTENT */}
      <main className="flex-1 px-8 py-10">
        {children}
      </main>
    </div>
  );
}
